import { Caption, Container, Text } from 'components/credits/credit-details/CreditItemDetailsFooter/components';

import { Arrangement } from 'types/arrangement';
import { Articulation } from 'types/articulation';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { Precedent } from 'types/precedent';
import { Spin } from 'antd';
import { reverseDateFormat } from 'utils/common';
import useTranslation from 'hooks/use-translation';

type Props =
  | { articulation: Articulation; creditType: CreditType.ARTICULATION }
  | { precedent: Precedent; creditType: CreditType.PRECEDENT };

export default function CreditItemDetailsFooter(props: Props): JSX.Element {
  const { creditType } = props;
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  let validDateString = translation.details.validDates.description;

  if (creditType === CreditType.ARTICULATION) {
    const { articulation } = props;
    const earliestStartDate = articulation.arrangements.reduce<Arrangement>(
      (earliest, arrangement) => (arrangement.startDate < earliest.startDate ? arrangement : earliest),
      articulation.arrangements[0],
    );

    if (earliestStartDate.endDate) {
      validDateString += ` between ${reverseDateFormat(earliestStartDate.startDate)} and ${reverseDateFormat(
        earliestStartDate.endDate,
      )}`;
    } else {
      validDateString += ` from ${reverseDateFormat(earliestStartDate.startDate)} onwards`;
    }
  } else if (creditType === CreditType.PRECEDENT) {
    const { precedent } = props;
    if (precedent.endDate) {
      validDateString += ` between ${reverseDateFormat(precedent.startDate)} and ${reverseDateFormat(
        precedent.endDate,
      )}`;
    } else {
      validDateString += ` from ${reverseDateFormat(precedent.startDate)} onwards`;
    }
  }
  return (
    <Container className='conditions-container'>
      <FlexContainer flex={2} gap={16}>
        <Caption className='conditions-heading'>{translation.details.conditions.title}</Caption>
        <Text>{translation.details.conditions.description}</Text>
        <ul>
          {translation.details.conditions.list.map((listItem) => {
            return (
              <li key={listItem}>
                <Text>
                  <span dangerouslySetInnerHTML={{ __html: listItem }} />
                </Text>
              </li>
            );
          })}
        </ul>
      </FlexContainer>
      <FlexContainer flex={1} gap={16}>
        <Caption className='valid-dates-heading'>{translation.details.validDates.title}</Caption>
        <Text>{validDateString}</Text>
      </FlexContainer>
    </Container>
  );
}
